/**
 * Alaska Reserve — fade-up la intrarea în viewport.
 * Elementele cu .brand-fade-up primesc .is-visible o singură dată.
 * Cu prefers-reduced-motion sau fără IntersectionObserver, totul e vizibil imediat (CSS-ul are fallback).
 */
(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  const reveal = (observer) => {
    document.querySelectorAll('.brand-fade-up:not(.is-visible)').forEach((el) => observer.observe(el));
  };

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      }
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }
  );

  reveal(observer);

  // Secțiunile Horizon se pot re-randa (theme editor, morph) — re-atașează observerul.
  document.addEventListener('shopify:section:load', () => reveal(observer));
})();

/**
 * Alaska Reserve — meniul „New in" devine un placeholder „Coming soon!".
 * Panoul mega-menu al intrării „New in" își pierde linkurile/cardurile și
 * arată doar textul centrat, care nu poate fi clickuit (pointer-events:none).
 */
(() => {
  const markComingSoonPanel = () => {
    const trigger = [...document.querySelectorAll('.menu-list__link')].find(
      (a) => a.querySelector('.menu-list__link-title')?.textContent.trim() === 'New in'
    );
    const panel = trigger && trigger.getAttribute('aria-controls')
      ? document.getElementById(trigger.getAttribute('aria-controls'))
      : null;
    if (panel) panel.classList.add('brand-coming-soon-menu');
  };

  /* meniul e randat de componentele Horizon după DOMContentLoaded — reîncercăm */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', markComingSoonPanel);
  } else {
    markComingSoonPanel();
  }
  [300, 1000, 2500].forEach((ms) => setTimeout(markComingSoonPanel, ms));
  document.addEventListener('shopify:section:load', markComingSoonPanel);
})();
